module.exports = __webpack_public_path__ + "img/calendar.08c9017f.svg";